import React from "react";
import { motion } from "framer-motion";
import PageTransition from "../components/PageTransition";
import { useApp } from "../context/AppContext";

const About = () => {
    const { t } = useApp();
    return (
        <PageTransition>
            <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24">
                <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
                    <div className="ornament-divider mb-8"><span className="font-arabic text-3xl text-gold">۞</span></div>
                    <h1 className="font-serif text-5xl mb-8">{t("nav.about")}</h1>
                </motion.div>
                <div className="space-y-6 text-bone/80 leading-relaxed">
                    <p>
                        {t("brand")}, Mekke ve Medine'de hizmet veren seçkin otellerimizle, hac ve umre yolculuğunuza
                        eşlik etmeyi şeref bilir. Türkiye'den gelen bireysel misafirlerimiz ve tur operatörü iş
                        ortaklarımız için titizlikle hazırlanmış konaklama çözümleri sunarız.
                    </p>
                    <p>
                        Harem-i Şerif ve Mescid-i Nebevi'ye yürüme mesafesindeki otellerimiz; konforu, manevi atmosferi
                        ve dürüst fiyat politikamızı buluşturur. Rezervasyonunuz ekibimizce hızlıca onaylanır,
                        ödemenizi güvenli şekilde gerçekleştirirsiniz.
                    </p>
                    <p>
                        WhatsApp üzerinden 7/24 destek ekibimiz; rezervasyon, oda değişikliği ve özel taleplerinizde
                        yanınızdadır. Mübarek yolculuğunuzun her anında huzur içinde olmanız bizim için en büyük
                        önceliktir.
                    </p>
                </div>
            </div>
        </PageTransition>
    );
};

export default About;
